export const PROGRAM_LABELS: Record<string, string> = {
  yatirim_tesvik: "Yatırım Teşvik Belgesi",
  kosgeb: "KOSGEB",
  tkdk_ipard: "TKDK / IPARD",
  ihracat: "İhracat Destekleri",
  tubitak: "TÜBİTAK Ar-Ge",
  kalkinma_ajansi: "Kalkınma Ajansı",
};

export const PROGRAM_INSTITUTIONS: Record<string, string> = {
  yatirim_tesvik: "Sanayi ve Teknoloji Bakanlığı",
  kosgeb: "KOSGEB",
  tkdk_ipard: "TKDK",
  ihracat: "Ticaret Bakanlığı",
  tubitak: "TÜBİTAK",
  kalkinma_ajansi: "Kalkınma Ajansı",
};

export const SECTORS = [
  "İmalat",
  "Tarım ve Hayvancılık",
  "Gıda",
  "Tekstil",
  "Madencilik",
  "Enerji",
  "Turizm ve Otelcilik",
  "İnşaat",
  "Sağlık",
  "Eğitim",
  "Lojistik ve Taşımacılık",
  "Bilişim ve Teknoloji",
  "Kimya",
  "Otomotiv",
  "Savunma Sanayii",
  "Diğer",
];

export const SUPPORT_RATE_OPTIONS = [
  "%25",
  "%30",
  "%40",
  "%50",
  "%50-70",
  "%60",
  "%70",
  "%75",
  "%100",
  "Diğer",
];

export const PROJECT_STATUS: Record<string, { label: string; color: string }> = {
  active: { label: "Aktif", color: "text-green-400 bg-green-500/10 border-green-500/20" },
  on_hold: { label: "Beklemede", color: "text-yellow-400 bg-yellow-500/10 border-yellow-500/20" },
  completed: { label: "Tamamlandı", color: "text-blue-400 bg-blue-500/10 border-blue-500/20" },
  cancelled: { label: "İptal", color: "text-red-400 bg-red-500/10 border-red-500/20" },
};

export const STAGE_STATUS: Record<string, { label: string; color: string }> = {
  pending: { label: "Bekliyor", color: "text-muted-foreground" },
  active: { label: "Devam Ediyor", color: "text-accent" },
  completed: { label: "Tamamlandı", color: "text-green-400" },
  skipped: { label: "Atlandı", color: "text-muted-foreground/50" },
};

export const NOTE_TYPES: Record<string, { label: string }> = {
  note: { label: "Not" },
  phone: { label: "Telefon" },
  email: { label: "E-posta" },
  meeting: { label: "Toplantı" },
};
